import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-digital-identity-tools",
  templateUrl: "./digital-identity-tools.component.html",
  styleUrls: ["./digital-identity-tools.component.scss"],
})
export class DigitalIdentityToolsComponent {
  constructor(private router: Router) {}

  openAuthoringTools() {
    this.router.navigate(["digital-identity/auth-tools"]);
  }
}
